import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const availableModalState = ['none', 'writable'] as const;
export type ModalState = (typeof availableModalState)[number];

type InitialState = {
  modalState: ModalState;
};

const initialState: InitialState = {
  modalState: 'none',
};

export const generatePortfolioSlice = createSlice({
  name: 'generatePortfolioSlice',
  initialState,
  reducers: {
    setGeneratePortfolioModalState: (state, { payload }: PayloadAction<ModalState>) => {
      state.modalState = payload;
    },
    closeGeneratePortfolioModal: (state) => {
      state.modalState = 'none';
    },
  },
  selectors: {
    selectGeneratePortfolioModalState: (state) => state.modalState,
  },
});

export const { closeGeneratePortfolioModal, setGeneratePortfolioModalState } =
  generatePortfolioSlice.actions;
export const { selectGeneratePortfolioModalState } = generatePortfolioSlice.selectors;
